import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <div className="loaderOuter"></div>
      <div className="loaderInner"></div>
    </div>
  );
};

export default Loader;
